import { AppBar, Box, CircularProgress, Grid, Tab, Tabs, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getMatchDetail } from "../../../actions/matchDetail.js";
import GameFact from "../../Live/gameFact/GameFact.js";
import GameFactFilter from "../../Live/gameFact/GameFactFilter.js";
import { useScoreResolver } from "../../Live/header/useScoreResolver.js";
import LiveHistorique from "../../Live/historique/LiveHistorique.js";

import avatar from '../../../images/empty_team.jpg'

import useStyles from './styles.js'
import { getSurchargePeriod } from "../../Live/sports/rules.js";

const PostMatch = () => {
    const {id : idMatch } = useParams();

    const dispatch = useDispatch()

    const classes =  useStyles()

    // dispatches the getMatchDetail action when idMatch changes
    useEffect(() => {
        if (idMatch) {
            dispatch(getMatchDetail(idMatch));
        }
    }, [idMatch, dispatch]);

    // Access match details from Redux store
    const match = useSelector((state) => state.matchDetail)

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [activeGameFact, setActiveGameFact] = useState()
    

    const enterGameFact = (id) => {
        setActiveGameFact(id)
      }
    
      const leaveGameFact = () => {
        setActiveGameFact(undefined)
      }

      const [surchargePeriod, setSurchargePeriod] = useState(undefined)

        useEffect(() => {
            if (match) {
                let surchargePeriod = match.period;
                
                if(['handball'].includes(match.discipline)){
                    surchargePeriod = getSurchargePeriod(match.discipline, match.period)  || match.period;
                }

                setSurchargePeriod(surchargePeriod);
            }
        }, [match]);
    
        
    return (
        <>
        <MatchHeader match={match}/>

        <Box sx={{ width: '100%', padding :  0}}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" indicatorColor="secondary" textColor="inherit" variant="fullWidth" >
                    <Tab label="Faits de jeux" {...a11yProps(0)}/>
                    <Tab label="Historique" {...a11yProps(1)}/>
                </Tabs>
                </AppBar>
            </Box>
            <TabPanel value={value} index={0} className={classes.tab}>
                {activeGameFact ? <GameFact gameFact={{type : activeGameFact}} endProcess={leaveGameFact} match={match}/> : 
                <GameFactFilter match={match} enterGameFact={enterGameFact} surchargePeriod={surchargePeriod}/>}
            </TabPanel>
            <TabPanel value={value} index={1} className={classes.tab}>
                <LiveHistorique match={match}/>
            </TabPanel>
        </Box>
        </>
    )
}

const MatchHeader = ({match}) => {

    const [homeScore, awayScore] = useScoreResolver(match)

    return (
        match && (match.idMatch || match.idActu) ?
        match.homeTeam ? 
        <Box>
            <Grid container py={2} sx={{justifyContent : "center", alignItems : 'center', background : '#3160a338'}}>
                <Grid item xs={1} textAlign={"right"}>
                    <img src={match.homeTeam.logo ?? avatar} style={{width : '90%'}}></img>
                </Grid>
                <Grid item xs={11} sm={3} textAlign={"left"} paddingLeft={'5%'}>
                    <Typography variant="h5">{match.homeTeam.name}</Typography>
                </Grid>
                <Grid item xs={12} sm={4} textAlign={"center"}>
                    <Typography variant="h4">{homeScore} - {awayScore}</Typography>
                </Grid>
                <Grid item xs={11} sm={3} textAlign={"right"} paddingRight={'5%'}>
                    <Typography variant="h5">{match.awayTeam.name}</Typography>
                </Grid>
                <Grid item xs={1} textAlign={"left"}>
                    <img src={match.awayTeam.logo ?? avatar} style={{width : '90%'}}></img>
                </Grid>
            </Grid>
        </Box> : <Box>{match.name}</Box>
        :
        <CircularProgress/>
    )

}

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

export default PostMatch